'use strict';

import {EwSiteApp} from '../../app/ewsiteapp';

EwSiteApp.controller('gepFormCtrl',['$scope', '$http', '$sce', function($scope, $http, $sce){
	$scope.sumbitted = false;
	$scope.message = '';
	$scope.objnrCheckUrl = guaranteedelectricityprivateData.data_url;
	$scope.obj_nr = '';
	$scope.checking_objnr = false;
	$scope.objNrValid = false;
	$scope.daily_message = '';
	$scope.daily_required = false;
	$scope.dailyValid = true;
	$scope.night_message = '';
	$scope.night_required = false;
	$scope.nightValid = true;
	$scope.loading = false;
	$scope.object = '';
	$scope.aut = false;
	$scope.scales = {};
	$scope.form;
	
			
//	$scope.$watch("phone", function (newVal) {
//		if (newVal) {
//			$scope.fullPhone = '+370' + newVal;
//		} else {
//			$scope.fullPhone = '';
//		}
//	});

	$scope.onChange = function(){
		if (typeof $scope.obj_nr !== 'undefined') {
			let valStr = $scope.obj_nr.toString();
			$scope.obj_nr = valStr.replace(/[^0-9]/g, '').substring(0, 8);
			if($scope.obj_nr.length===8 || $scope.objNrValid){
				$scope.checkObjectNr();
			}
			if($scope.submitted && $scope.obj_nr.length<8){
				$scope.message = '';
				$scope.daily_message = '';
				$scope.night_message = '';
			}
		}
	};

	$scope.onDailyScaleChange = function(){
		if (typeof $scope.daily !== 'undefined') {
			if(typeof($scope.scales.daily) !== 'undefined'){
				if(($scope.daily-$scope.scales.daily.rdm_sumine_reiksme)>=5000){
					$scope.dailyValid = false;
					$scope.daily_message = $sce.trustAsHtml(declared_values_exceeds_5000);
				}
				else if($scope.daily<$scope.scales.daily.rdm_sumine_reiksme){
					$scope.dailyValid = false;
					$scope.daily_message = $sce.trustAsHtml(declared_values_not_real);
				}
				else {
					$scope.dailyValid = true;
				}
			}
		}
	};
	
	$scope.onNightChange = function(){
		if (typeof $scope.night !== 'undefined') {
			if(typeof($scope.scales.night) !== 'undefined'){
				if(($scope.night-$scope.scales.night.rdm_sumine_reiksme)>=5000){
					$scope.nightValid = false;
					$scope.night_message = $sce.trustAsHtml(declared_values_exceeds_5000);
				}
				else if($scope.night<$scope.scales.night.rdm_sumine_reiksme){
					$scope.nightValid = false;
					$scope.night_message = $sce.trustAsHtml(declared_values_not_real);
				}
				else {
					$scope.nightValid = true;
				}
			}
		}
	};

	$scope.checkObjectNr = function(){
		$scope.message = '';
		$scope.checking_objnr = true;
		if($scope.objnrCheckUrl !== ''){
			$http({
				method: 'POST',
				url: $scope.objnrCheckUrl,
				data: {
					nr: $scope.obj_nr
				},
				xsrfCookieName: secure_xsrf_name,
				xsrfHeaderName: 'X-' + secure_xsrf_name
			}).then(function(response){
				$scope.submitted = true;
				$scope.objNrValid = response.data.success;
				if(response.data.success) {
					if(response.data.aut){
						$scope.aut = true;
						$scope.objNrValid = false;
					}
					$scope.object = response.data.object;
					$scope.scales = response.data.scales;
					if(typeof($scope.scales.daily) !== 'undefined'){
						$scope.daily_required = true;
					}
					if(typeof($scope.scales.night) !== 'undefined'){
						$scope.night_required = true;
					}
				}
				if(response.data.message) {
					$scope.message = $sce.trustAsHtml(response.data.message);
				}
			}, function(response){
				console.log(['Error', response]);
			}).then(function(){
				$scope.checking_objnr = false;
			});
		}
	};
	
	$scope.formSubmit = function (e) {
		e.preventDefault();
		$scope.submitted = true;
		
		/*let is_grecaptcha = $scope.form.find('#g-recaptcha-response-hidden').length > 0;
		if (is_grecaptcha && typeof (grecaptcha) !== 'undefined') {
			grecaptcha.ready(function () {
				grecaptcha.execute($('#g-recaptcha-response-hidden').data('sitekey'), {action: 'submit'}).then(function (token) {
					if (document.getElementById('g-recaptcha-response-hidden')) {
						$('#g-recaptcha-response-hidden').val(token);
					} else {
						var inp = document.createElement('input');
						inp.type = 'hidden';
						inp.name = 'g-recaptcha-response';
						inp.value = token;
						$scope.form[0].appendChild(inp);
					}
					$scope.form[0].submit();
				});
			});
		} else {*/
			$scope.form[0].submit();
		/*}*/
	};
	
}]).directive('formSubmit', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			scope.form = angular.element(element);
		}
	};
});

//EwSiteApp.directive('numbersOnly', function () {
//	return {
//		restrict: 'A',
//		scope: {
//			value: '=ngModel'
//		},
//		controller: function ($scope) {
//			$scope.$watch(function () {
//				return $scope.value;
//			}, function (newVal) {
//				if (typeof newVal !== 'undefined') {
//					$scope.value = newVal.replace(/[^0-9\+]/g, '');
//				}
//			});
//		}
//	};
//});